import React, { useState } from 'react';

import Header from '../../main/components/Header';
import Path from '../../path/ui/Path';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import { t } from 'i18next';
import { NotifFilterTabButtons } from '../components/NotifFilterTabButtons';

import Icon from '../../../common/components/Icon';

import '../style/Notification.css';
import Articles from '../../aboutus/components/Articles';

const Main = () => {
    const [tab, setTab] = useState('agroland');
    return (
        <div className="w-full">
            <Header />
            <Path currentPath={t('notifications')} />
            <div className="flex flex-col items-center justify-center gap-5 md:gap-5 pt-0 md:pt-5 px-4 md:px-[var(--large-padding)] pb-20 md:pb-0 w-full max-w-full">
                <div className="flex flex-col justify-center w-full max-w-[1060px] max-[768px]:max-w-full">
                    <div className="flex flex-col gap-4 md:gap-4 p-4 md:p-0 mb-2 md:mb-0 bg-white md:bg-transparent rounded-none">
                        <Icon src="backicon" className="block md:hidden cursor-pointer w-6 h-6 mb-0" />
                        <h2 className="text-2xl font-bold m-0 mt-1">{t('news')}</h2>
                        <NotifFilterTabButtons tab={tab} setTab={setTab} />
                    </div>
                    {tab === 'agroland' && <Articles service="service" />}
                    {tab === 'promotions' && <Articles service="promotions" />}
                </div>
            </div>
            <div className="mt-5">
                <MobileBottomBar />
            </div>
        </div>
    );
};

export default Main;
